import React from 'react';
import { Code, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-slate-950/70 backdrop-blur-xl border-t border-slate-800/50 py-12 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center mb-4">
              <Code className="text-blue-500 mr-2" size={24} />
              <span className="text-xl font-outfit font-bold bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent">
                CV. Quantum Byte Studio
              </span>
            </div>
            <p className="text-slate-400 font-inter text-sm">
              Transforming ideas into elegant software solutions since 2020.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-outfit font-medium mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#hero" data-testid="footer-link-home" className="text-slate-400 hover:text-blue-400 font-inter text-sm transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="#services" data-testid="footer-link-services" className="text-slate-400 hover:text-blue-400 font-inter text-sm transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a href="#portfolio" data-testid="footer-link-portfolio" className="text-slate-400 hover:text-blue-400 font-inter text-sm transition-colors">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="#contact" data-testid="footer-link-contact" className="text-slate-400 hover:text-blue-400 font-inter text-sm transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-outfit font-medium mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center" data-testid="footer-phone">
                <Phone className="text-blue-500 mr-3" size={16} />
                <a href="tel:088228079946" className="text-slate-400 hover:text-blue-400 font-inter text-sm transition-colors">
                  +62 882-2807-9946
                </a>
              </div>
              <div className="flex items-center" data-testid="footer-email">
                <Mail className="text-blue-500 mr-3" size={16} />
                <span className="text-slate-400 font-inter text-sm">
                  admin@quantumbytestudio.co.id
                </span>
              </div>
              <div className="flex items-center">
                <MapPin className="text-blue-500 mr-3" size={16} />
                <span className="text-slate-400 font-inter text-sm">
                  Jember, Indonesia
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800/50 pt-8">
          <p className="text-center text-slate-500 font-inter text-sm" data-testid="footer-copyright">
            © {currentYear} CV. Quantum Byte Studio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;